export const formatReferenceValuePath = (value: string) =>
  value.replace(/\(|\)|\?/g, '');

export const isReferencedValue = (value: string) =>
  value.startsWith('(') && (value.endsWith(')') || value.endsWith(')?'));
